exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-title[data-v-6dcbac03]{background-color:#f44336;color:#fff;width:100%}", ""]);

// exports
